import RoundedButton from "./RoundedButton";
export type { RoundedButtonProps } from "./types";
export default RoundedButton;
